import React, { useState, useEffect } from 'react';
import MasterPage from 'components/MasterPage';
import { Container, Row, Col, Card, Form, Badge } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import { parseDateBR } from '../../helpers/date';


import styles from './style.module.scss';
import QuoteRequestService from 'services/quote-request';

// const Description = ({ description }) => (
// 	<>
// 		<span>{description}</span>

// 	</>
// );

const Reports = () => {
	const defaultFilters = { search: '', per_page: 10, page: 1, current_page: 0, status: "" };
	const [filters, setFilters] = useState(defaultFilters);
	const [leads, setLeads] = useState([]);
	const [pagination, setPagination] = useState({
		current_page: 0,
    from: 0,
    last_page: 0,
    path: "",
    per_page: 0,
    to: 0,
    total: 0
	});

	useEffect(() => {
		getLeads();
	},[filters]);

	const getLeads = () => {
		QuoteRequestService.getReportByStatus({ params: { ...filters }})
		.then(({ data }) => {
			const { data: response } = data;

			let arrayLeads = response.map((lead) => {
				return {
					id: lead.id,
					hubspot_id: lead.hubspot_id,
					deal_name: lead.deal_name,
					//description: <Description description={lead.description}/>,
					hubspot_status: statusName(lead.hubspot_status_id),
					deal_created_at: parseDateBR(lead.deal_created_at),
					manufacturers_name: lead.manufacturers_name,
					local_name: `${lead.city_name} - ${lead.state_name}`
				}
			});
			setLeads(arrayLeads);
			setPagination(paginationObj(data));
		});
	}

	const paginationObj = data => {
		return {
			current_page: data.current_page,
			from: data.from,
			last_page: data.last_page,
			path: "",
			per_page: data.per_page,
			to: data.to,
			total: data.total
		}
	}

	const handleFilterChange = (new_filters, reset = false) => {

    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
	};

	const handlePageChange = page => handleFilterChange({ page });

	const statusName = status_id => {
		const statuses = [];
		statuses[1] = {label: "Ganho", color: "success"};
		statuses[2] = {label: "Perdido", color: "danger"};
		statuses[3] = {label: "Assignado", color: "secondary"};
		statuses[4] = {label: "Em Negociação", color: "primary"};
		statuses[5] = {label: "Esperando Feedback", color: "dark"};

		return (
			<Badge variant={statuses[status_id].color}>
				{statuses[status_id].label}
			</Badge>
		);
	}
	
	const columns = [
    {
      dataField: 'hubspot_id',
      text: 'ID Hubspot',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'deal_name',
      text: 'Nome do Negócio',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
		},		
    // {
    //   dataField: 'description',
    //   text: 'Descrição',
    //   headerStyle: {
    //     textAlign: 'center'
    //   },
    //   style: {
    //     textAlign: 'center'
    //   }
    // },
    {
      dataField: 'manufacturers_name',
      text: 'Fabricante',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'local_name',
      text: 'Local',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'deal_created_at',
      text: 'Data do Lead',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },

    {
      dataField: 'hubspot_status',
      text: 'Status',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
  ];

	return (
		<Container fluid>
			<Row>
				<Col>
					<Card>
						<Card.Body>
							<Row>
								<Col xs={6} className="align-self-center">
									<h4 className={styles.headerTitle}>
										Relatório de Leads por Status
									</h4>
								</Col>
							</Row>
							<Row>
								<Col>
									<hr className={styles.line} />
								</Col>
							</Row>
							<Row>
								<Col xs={3}  className="d-flex justify-content-start">
									<Form.Group>
										<Form.Label>Registros por página:</Form.Label>
										<Form.Control
											as="select"
											value={filters.per_page}
											onChange={e =>
												handleFilterChange({ per_page: e.target.value, page: 1 })
											}
										>
											<option value={10}>10</option>
											<option value={25}>25</option>
											<option value={50}>50</option>
											<option value={100}>100</option>
										</Form.Control>
									</Form.Group>
								</Col>
								<Col xs={{ offset: 2 }}></Col>
								<Col xs={3}>
									<Form.Group>
										<Form.Label>Status:</Form.Label>
										<Form.Control
											as="select"
											value={filters.hubspot_status_id}
											onChange={e =>
												handleFilterChange({ hubspot_status_id: e.target.value, page: 1 })
											}
										>
											<option value={""} selected>Selecione o Status</option>
											<option value={1}>Ganho</option>
											<option value={2}>Perdido</option>
											<option value={3}>Assignado</option>
											<option value={4}>Em Negociação</option>
											<option value={5}>Esperando Feedback</option>
										</Form.Control>
									</Form.Group>
								</Col>
								<Col xs={3} className="d-flex justify-content-end">
									<Form.Group>
										<Form.Label>Busca:</Form.Label>
										<Form.Control
											onChange={e =>
												handleFilterChange({ search: e.target.value })
											}
											value={filters.search}
										>
										</Form.Control>
									</Form.Group>
								</Col>
							</Row>
							<BootstrapTable
								id="table"
								keyField="id"
								data={leads}
								columns={columns}
							/>
							<Row>
								<Col>
									<Trans i18nKey="label:interpolateShowingRecords">
										Showing {{ from: pagination.from || '0' }} to{' '}
										{{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
										records
									</Trans>
								</Col>
								<Col className="d-flex justify-content-end">
									<Pagination 
										activePage={pagination.current_page}
										itemsCountPerPage={pagination.per_page}
										totalItemsCount={pagination.total}
										onChange={handlePageChange}
										pageRangeDisplayed={5}
										itemClass="page-item"
										linkClass="page-link"
										prevPageText="‹"
										nextPageText="›"
									/>
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	);
}


export default MasterPage(Reports);